import { CurrentRoleData } from '~/modules/settings/_state/roleForm.state';
import { createQueryHook } from '~/shared/providers/api';

export interface RoleQueryParams {
  roleId: string;
}

export interface RoleQueryResult {
  role: CurrentRoleData | null;
}

/**
 * Query hook for fetching a single role with its permissions.
 */
export const useRoleQuery = createQueryHook(
  'settings.teamPermissions.role',
  (params: RoleQueryParams) => ({
    coreRole: {
      __args: { id: params.roleId },
      id: true,
      name: true,
      description: true,
      permissions: true,
      archived: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
  {
    select: (data): RoleQueryResult => ({
      role: data?.coreRole
        ? {
            id: data.coreRole.id,
            name: data.coreRole.name,
            description: data.coreRole.description ?? null,
            permissions: data.coreRole.permissions ?? [],
            status: data.coreRole.archived ? 'archived' : 'active',
            updatedAt: data.coreRole.timestamps?.updatedAt ?? null,
            updatedBy: null,
          }
        : null,
    }),
  },
);
